import PropTypes from 'prop-types';
import products from './products';

export default PropTypes.shape({
  origin: PropTypes.shape({
    uic: PropTypes.string
  }),
  destination: PropTypes.shape({
    uic: PropTypes.string
  }),
  date: PropTypes.string,
  serviceName: PropTypes.string,
  serviceIdentifier: PropTypes.string,
  bookingItems: products
});
